module.exports = __webpack_public_path__ + "static/img/aon.bf0b24ca.svg";